import { render, staticRenderFns } from "./WhirelabSnackbar.vue?vue&type=template&id=146e1834"
import script from "./WhirelabSnackbar.vue?vue&type=script&lang=js"
export * from "./WhirelabSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports